import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosCabinet } from "../../api/axios";
import { CABINET_DASHBOARD_PATHS } from "../../api/endpoints";

const rejectMsg = (err, fallback) => ({
  message: err?.response?.data?.message || err?.message || fallback,
});

/** Fetch today's stats (appointments, waiting, completed, revenue) */
export const fetchDashboardStats = createAsyncThunk(
  "cabinetDashboard/fetchStats",
  async (date, { rejectWithValue }) => {
    try {
      const { data } = await axiosCabinet.get(
        CABINET_DASHBOARD_PATHS.STATS(date)
      );
      return data;
    } catch (err) {
      return rejectWithValue(rejectMsg(err, "Failed to fetch dashboard stats"));
    }
  }
);

/** Fetch appointments for calendar view */
export const fetchCalendarAppointments = createAsyncThunk(
  "cabinetDashboard/fetchCalendarAppointments",
  async ({ date, view }, { rejectWithValue }) => {
    try {
      const { data } = await axiosCabinet.get(
        CABINET_DASHBOARD_PATHS.APPOINTMENTS(date, view)
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        rejectMsg(err, "Failed to fetch calendar appointments")
      );
    }
  }
);
